export class GeneralConfirmationModalData {
  title: string;
  message?: string;
  confirmButton: GeneralConfirmationModalResult | undefined;
  customButton: GeneralConfirmationModalResult | undefined;
  cancelButton: GeneralConfirmationModalResult | undefined;
  confirmButtonText?: string | "CONFIRM" | "OK";
  useInnerHtml: boolean = false;
  isImage: boolean = false;
  imageSrc?: string;
  textAlign: string = 'center';

  constructor(title: string, confirmButton: GeneralConfirmationModalResult | undefined, cancelButton: GeneralConfirmationModalResult | undefined, customButton: GeneralConfirmationModalResult | undefined, message?: string, useInnerHtml: boolean = false, isImage = false, imageSrc?: string) {
    this.title = title;
    this.message = message;
    this.confirmButton = confirmButton;
    this.cancelButton = cancelButton;
    this.customButton = customButton;
    this.useInnerHtml = useInnerHtml;
    this.isImage = isImage;
    this.imageSrc = imageSrc;
  }
}

export enum GeneralConfirmationModalResult {
  None,
  Confirm,
  Custom,
  Cancel
}

export interface PetBreedDTO {
  id: string;
  name: string;
}

export interface PhotoCaptureModalResult {
  pdfBlob?: Blob;
}

export interface PhotoCaptureModalData {
  /** Upload budget the generated PDF has to stay within, if the host imposes one. */
  maxSizeBytes?: number;
}

/**
 * Result emitted by the side modal when it closes, telling the host
 * (desktop-side-subcomponent) what to do with the route afterwards.
 *
 * NOTE: External/auto closes (backdrop click, ESC, dialog.closeAll) emit
 * `undefined` on afterClosed. `undefined` is intentionally treated as
 * `NavigateHome` by the host so dismissing a detail modal returns home.
 * When a caller navigates elsewhere itself, it MUST close with
 * `KeepCurrentRoute` so the host does not override that navigation.
 */
export enum SideModalCloseAction {
  NavigateHome = 'navigate-home',
  KeepCurrentRoute = 'keep-current-route',
}

export enum SideModalComponentTypeEnum {
  None,
  ClaimDetail,
  InvoiceDetail,
  EditPetInfo,
  EditInsuranceInfo,
  ViewInsuranceDetail,
  CancelInsurance,
  PetFnol,
  Account,
  AccountEdit,
  AccountChangePassword,
  AccountChangeIban,
  AccountForgotPassword,
  AccountContactUs,
  AccountVouchers,
  AccountVoucherDetails,
  FnolDetails,
  Chat,
  ChatHistory,
  ChatClaimDetails
}
